import { render, staticRenderFns } from "./TableProductIndex.vue?vue&type=template&id=715cf0ed&scoped=true&"
import script from "./TableProductIndex.vue?vue&type=script&lang=js&"
export * from "./TableProductIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715cf0ed",
  null
  
)

export default component.exports